import { Camera, Clock3, Flame, Heart, ImagePlus, PenLine, Share2, SlidersHorizontal, Type, Users } from 'lucide-react';
import PhoneShot from '../ui/PhoneShot';
import { APP_SCREENS } from '../../appScreens';

// Each step is shown with the real app screen the customer sees at that point of the flow.
const steps = [
    {
        number: '۱',
        tone: 'coral',
        screen: APP_SCREENS.newRecipe,
        kicker: 'امروز چی بپزیم؟',
        title: 'بگو توی آشپزخانه‌ات چی داری',
        text: 'اسم مواد یا غذای دلخواهت را بنویس، یا حوصله تایپ نداری از یخچالت عکس بگیر تا هوش‌پز مواد را خودش پیدا کند. قبل از ساخت، فهرست را هر جور خواستی کم و زیاد کن.',
        chips: [
            { icon: Type, label: 'نوشتن مواد' },
            { icon: Camera, label: 'دوربین' },
            { icon: ImagePlus, label: 'گالری' },
        ],
    },
    {
        number: '۲',
        tone: 'green',
        screen: APP_SCREENS.recipeResult,
        kicker: 'دستورت آماده است',
        title: 'سلیقه‌ات را بگو، دستور کامل تحویل بگیر',
        text: 'رژیم، حساسیت، زمان، تعداد نفرات و وسایل در دسترس را تنظیم کن. دستور پخت فارسی با مقدار مواد، مراحل مرتب، زمان، سختی و کالری تقریبی ساخته می‌شود؛ بعد از پخت هم بگو پختی یا نه تا دستورهای بعدی دقیق‌تر شوند.',
        chips: [
            { icon: SlidersHorizontal, label: 'رژیم و حساسیت' },
            { icon: Clock3, label: 'زمان پخت' },
            { icon: Users, label: 'تعداد نفرات' },
            { icon: Flame, label: 'کالری تقریبی' },
        ],
    },
    {
        number: '۳',
        tone: 'saffron',
        screen: APP_SCREENS.recipeDetail,
        kicker: 'مال خودت کن',
        title: 'ویرایشش کن، نگهش دار، بفرستش',
        text: 'یک ماده را عوض کن یا کالری را پایین بیاور تا نسخه تازه‌ای از همان غذا ساخته شود. دستورهای محبوبت را نشان کن و با یک لینک برای خانواده و دوستانت بفرست.',
        chips: [
            { icon: PenLine, label: 'ویرایش هوشمند' },
            { icon: Heart, label: 'علاقه‌مندی‌ها' },
            { icon: Share2, label: 'اشتراک‌گذاری' },
        ],
    },
];

const HowItWorks = () => (
    <section id="how-it-works" className="section how-section">
        <div className="site-container">
            <div className="section-heading compact">
                <span>فقط سه قدم تا غذای بعدی</span>
                <h2>ساخت دستور پخت در سه قدم ساده</h2>
                <p>این‌ها تصویرهای واقعی از اپ هوش‌پز هستند؛ همان چیزی که بعد از نصب می‌بینی.</p>
            </div>
            <div className="tour-list">
                {steps.map(({ number, tone, screen, kicker, title, text, chips }) => (
                    <article className={`tour-step tone-${tone}`} key={number}>
                        <div className="tour-visual">
                            <div className="tour-backdrop" aria-hidden="true" />
                            <PhoneShot screen={screen} />
                        </div>
                        <div className="tour-copy">
                            <div className="tour-kicker"><b>{number}</b>{kicker}</div>
                            <h3>{title}</h3>
                            <p>{text}</p>
                            <ul className="tour-chips">
                                {chips.map(({ icon: Icon, label }) => (
                                    <li key={label}><Icon size={16} /> {label}</li>
                                ))}
                            </ul>
                        </div>
                    </article>
                ))}
            </div>
        </div>
    </section>
);

export default HowItWorks;
